import axios from 'axios';
import { API_CONFIG } from '../config/api';

export const SUPPORTED_REGIONS = [
    { id: 'IN', name: 'India', flag: '🇮🇳', langName: 'English, Hindi, বাংলা, मराठी, తెలుగు, ಕನ್ನಡ', defaultLang: 'en-IN' },
    { id: 'US', name: 'United States', flag: '🇺🇸', langName: 'American English', defaultLang: 'en-US' },
    { id: 'GB', name: 'United Kingdom', flag: '🇬🇧', langName: 'British English', defaultLang: 'en-GB' }
];

export const getCoachAvatar = (voice) => {
    if (!voice) return '/images/bots/coach.webp';
    if (voice.avatarUrl && typeof voice.avatarUrl === 'string') return voice.avatarUrl;
    if (voice.avatar && typeof voice.avatar === 'string') return voice.avatar;

    const id = (voice.id || '').toLowerCase();
    const name = (voice.name || '').toLowerCase();
    const gender = (voice.gender || '').toLowerCase();

    // Specific coach avatars
    if (id.includes('en-in-neural2-b') || name.includes('eklavya')) return '/images/bots/coach.webp';
    if (id.includes('en-in-neural2-a') || name.includes('maya')) return '/images/bots/sofia.webp';
    if (id.includes('browser-en-in') || name.includes('rishi')) return '/images/bots/adit.webp';
    if (id.includes('browser-female-in') || name.includes('priya')) return '/images/bots/sofia.webp';
    if (name.includes('ananya') || name.includes('tanvi')) return '/images/bots/frida.webp';
    if (name.includes('aarohi') || name.includes('keerthi')) return '/images/bots/izabel.webp';
    if (name.includes('sravani')) return '/images/bots/jade.webp';
    if (name.includes('spandana')) return '/images/bots/nora.webp';

    // US Coaches
    if (name.includes('marcus') || id.includes('neural2-j')) return '/images/bots/nelson.webp';
    if (name.includes('sarah') || id.includes('neural2-f')) return '/images/bots/eliza.webp';
    if (name.includes('david') || id.includes('browser-en-us') || id.includes('neural2-d')) return '/images/bots/david.webp';
    if (name.includes('elena') || id.includes('browser-female-us')) return '/images/bots/eliza.webp';

    // GB Coaches
    if (name.includes('arthur') || id.includes('en-gb-neural2-b')) return '/images/bots/fabian.webp';
    if (name.includes('victoria') || id.includes('en-gb-neural2-a')) return '/images/bots/sofia.webp';
    if (name.includes('oliver') || id.includes('browser-en-gb')) return '/images/bots/anish.webp';
    if (name.includes('charlotte') || id.includes('browser-female-gb')) return '/images/bots/eliza.webp';

    if (gender === 'female') return '/images/bots/sofia.webp';
    return DEFAULT_COACH_AVATAR;
};

export const DEFAULT_COACH_AVATAR = 'https://storage.googleapis.com/knightsteps/uploads/coach-avatars/defaults/default_default_closed_1789849410620.webp';

export const DEFAULT_COACH_AVATAR_STATES = {
    closed: 'https://storage.googleapis.com/knightsteps/uploads/coach-avatars/defaults/default_default_closed_1789849410620.webp',
    slightly_open: 'https://storage.googleapis.com/knightsteps/uploads/coach-avatars/defaults/default_default_slightly_open_1789849410894.webp',
    open: 'https://storage.googleapis.com/knightsteps/uploads/coach-avatars/defaults/default_default_open_1789849411458.webp',
    wide_open: 'https://storage.googleapis.com/knightsteps/uploads/coach-avatars/defaults/default_default_wide_open_1789849411625.webp',
    smile: 'https://storage.googleapis.com/knightsteps/uploads/coach-avatars/defaults/default_default_smile_1789849411782.webp'
};

export const COACH_DAVID = {
    id: 'en-US-Neural2-D',
    name: 'David',
    title: 'Coach David',
    region: 'US',
    tier: 'pro',
    gender: 'Male',
    genderIcon: 'male',
    accent: 'USA (en-US)',
    langCode: 'en-US',
    avatarUrl: DEFAULT_COACH_AVATAR,
    avatarStates: DEFAULT_COACH_AVATAR_STATES,
    badge: '⚡ KS Neural AI',
    desc: 'Dynamic, clear and articulate American grandmaster voice',
    greeting: 'Hello! I am Coach David, ready to review your chess game.'
};

export const REGIONAL_COACHES = {
    IN: [
        // Free Models
        { 
            id: 'browser-en-IN', 
            name: 'Rishi', 
            title: 'Rishi', 
            region: 'IN', 
            tier: 'free', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'India (en-IN)', 
            langCode: 'en-IN', 
            avatarUrl: '/images/bots/adit.webp',
            badge: 'Free Device Synthesizer', 
            desc: 'Free Indian English voice powered by local device engine', 
            greeting: 'Hello! I am Rishi, ready to review your chess game.' 
        },
        { 
            id: 'browser-native-IN', 
            name: 'System Voice', 
            title: 'System Voice', 
            region: 'IN', 
            tier: 'free', 
            gender: 'System', 
            genderIcon: 'bot', 
            accent: 'Local Device', 
            langCode: 'local', 
            avatarUrl: '/images/bots/coach.webp',
            badge: 'Free Device Synthesizer', 
            desc: 'Direct device speech synthesizer with zero API cost', 
            greeting: 'Hello! I am your chess review voice, ready to analyze your game.' 
        },
        // Pro English Models
        { 
            id: 'en-IN-Neural2-B', 
            name: 'Eklavya', 
            title: 'Eklavya', 
            region: 'IN', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'India (en-IN)', 
            langCode: 'en-IN', 
            avatarUrl: '/images/bots/coach.webp',
            badge: '👑 KS Neural AI', 
            desc: 'Natural, deep and authoritative Indian grandmaster AI voice', 
            greeting: 'Hello! I am Eklavya, ready to review your chess game.' 
        },
        // Pro Regional Indian Languages
        { 
            id: 'hi-IN-Neural2-B', 
            name: 'Eklavya (Hindi)', 
            title: 'एकलव्य (हिंदी)', 
            region: 'IN', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'Hindi (hi-IN)', 
            langCode: 'hi-IN', 
            avatarUrl: '/images/bots/coach.webp',
            badge: '🇮🇳 KS Neural AI', 
            desc: 'स्पष्ट और प्रामाणिक हिंदी ग्रैंडमास्टर आवाज', 
            greeting: 'नमस्ते! मैं एकलव्य हूँ, आपके शतरंज के खेल की समीक्षा करने के लिए तैयार हूँ।' 
        },
        { 
            id: 'bn-IN-Wavenet-B', 
            name: 'Eklavya (Bengali)', 
            title: 'একলব্য (বাংলা)', 
            region: 'IN', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'Bengali (bn-IN)', 
            langCode: 'bn-IN', 
            avatarUrl: '/images/bots/coach.webp',
            badge: '🇮🇳 KS Neural AI', 
            desc: 'স্পষ্ট ও প্রাঞ্জল বাংলা গ্র্যান্ডমাস্টার ভয়েস', 
            greeting: 'নমস্কার! আমি একলব্য, আপনার দাবা খেলার পর্যালোচনা করতে প্রস্তুত।' 
        },
        { 
            id: 'mr-IN-Wavenet-B', 
            name: 'Eklavya (Marathi)', 
            title: 'एकलव्य (मराठी)', 
            region: 'IN', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'Marathi (mr-IN)', 
            langCode: 'mr-IN', 
            avatarUrl: '/images/bots/coach.webp',
            badge: '🇮🇳 KS Neural AI', 
            desc: 'स्पष्ट आणि अधिकृत मराठी ग्रँडमास्टर आवाज', 
            greeting: 'नमस्कार! मी एकलव्य आहे, तुमच्या बुद्धिबळाच्या खेळाचे विश्लेषण करण्यास तयार आहे.' 
        },
        { 
            id: 'te-IN-Standard-B', 
            name: 'Eklavya (Telugu)', 
            title: 'ఏకలవ్య (తెలుగు)', 
            region: 'IN', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'Telugu (te-IN)', 
            langCode: 'te-IN', 
            avatarUrl: '/images/bots/coach.webp',
            badge: '🇮🇳 KS Studio AI', 
            desc: 'స్పష్టమైన మరియు సహజమైన తెలుగు గ్రాండ్‌మాస్టర్ వాయిస్', 
            greeting: 'నమస్కారం! నేను ఏకలవ్యను, మీ చదరంగం ఆటను విశ్లేషించడానికి సిద్ధంగా ఉన్నాను.' 
        },
        { 
            id: 'kn-IN-Wavenet-B', 
            name: 'Eklavya (Kannada)', 
            title: 'ಏಕಲವ್ಯ (ಕನ್ನಡ)', 
            region: 'IN', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'Kannada (kn-IN)', 
            langCode: 'kn-IN', 
            avatarUrl: '/images/bots/coach.webp',
            badge: '🇮🇳 KS Neural AI', 
            desc: 'ಸ್ಪಷ್ಟ ಮತ್ತು ನಿಖರವಾದ ಕನ್ನಡ ಗ್ರ್ಯಾಂಡ್‌ಮಾಸ್ಟರ್ ಧ್ವನಿ', 
            greeting: 'ನಮಸ್ಕಾರ! ನಾನು ಏಕಲವ್ಯ, ನಿಮ್ಮ ಚದುರಂಗದ ಆಟವನ್ನು ಪರಿಶೀಲಿಸಲು ಸಿದ್ಧನಾಗಿದ್ದೇನೆ.' 
        }
    ],
    US: [
        // Pro Models
        COACH_DAVID,
        { 
            id: 'en-US-Neural2-J', 
            name: 'Marcus', 
            title: 'Marcus', 
            region: 'US', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'USA (en-US)', 
            langCode: 'en-US', 
            avatarUrl: '/images/bots/nelson.webp', 
            badge: '⚡ KS Neural AI', 
            desc: 'Clear, dynamic and articulate American grandmaster voice', 
            greeting: 'Hello! I am Marcus, ready to review your chess game.' 
        }
    ],
    GB: [
        // Free Models
        { 
            id: 'browser-en-GB', 
            name: 'Oliver', 
            title: 'Oliver', 
            region: 'GB', 
            tier: 'free', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'UK (en-GB)', 
            langCode: 'en-GB', 
            avatarUrl: '/images/bots/anish.webp',
            badge: 'Free Device Synthesizer', 
            desc: 'Free British English voice powered by local device engine', 
            greeting: 'Hello! I am Oliver, ready to review your chess game.' 
        },
        // Pro Models
        { 
            id: 'en-GB-Neural2-B', 
            name: 'Arthur', 
            title: 'Arthur', 
            region: 'GB', 
            tier: 'pro', 
            gender: 'Male', 
            genderIcon: 'male', 
            accent: 'UK (en-GB)', 
            langCode: 'en-GB', 
            avatarUrl: '/images/bots/fabian.webp',
            badge: '🇬🇧 KS Neural AI', 
            desc: 'Refined classical English chess grandmaster voice', 
            greeting: 'Hello! I am Arthur, ready to review your chess game.' 
        }
    ]
};

export const ALL_COACH_VOICES = Object.values(REGIONAL_COACHES).flat();
export const AVAILABLE_COACH_VOICES = ALL_COACH_VOICES;

export const INSTANT_CHESS_PHRASEBOOK = {
    'hi': {
        "Find the best move!": "सर्वोत्तम चाल खोजें!",
        "Your turn! Find the best move.": "आपकी बारी! सर्वोत्तम चाल खोजें।",
        "Your turn! Find the next move.": "आपकी बारी! अगली चाल खोजें।",
        "That's not it. Try again!": "यह सही चाल नहीं है। पुनः प्रयास करें!",
        "Incorrect move. Try again or click \"Show Hint\".": "गलत चाल। पुनः प्रयास करें या 'Show Hint' पर क्लिक करें।",
        "Correct! Well done.": "सही चाल! बहुत बढ़िया।",
        "Correct move! Well done finding the winning solution.": "सही चाल! जीतने वाला समाधान खोजने के लिए बहुत बढ़िया।",
        "Good move! Waiting for opponent's response...": "अच्छी चाल! प्रतिद्वंद्वी के जवाब का इंतजार है...",
        "Puzzle completed!": "पहेली सफलतापूर्वक पूरी हुई!",
        "Puzzle completed! Excellent calculation and tactical precision.": "पहेली सफलतापूर्वक पूरी हुई! उत्कृष्ट गणना और tactical सटीकता।",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "शानदार खेल! आपने सही संयोजन खोजकर पहेली को सफलतापूर्वक हल कर लिया है।",
        "Brilliant! You solved today's **Daily Puzzle**. Outstanding tactical vision!": "शानदार! आपने आज की **Daily Puzzle** हल कर ली है। बेहतरीन tactical समझ!",
        "You already solved today's **Daily Puzzle**! Feel free to practice or replay it anytime.": "आप आज की **Daily Puzzle** पहले ही हल कर चुके हैं! आप कभी भी इसका अभ्यास या पुनरावृत्ति कर सकते हैं।",
        "No more moves to show.": "दिखाने के लिए और कोई चाल नहीं है।"
    },
    'bn': {
        "Find the best move!": "সেরা চালটি খুঁজুন!",
        "Your turn! Find the best move.": "আপনার পালা! সেরা চালটি খুঁজুন।",
        "Your turn! Find the next move.": "আপনার পালা! পরবর্তী চালটি খুঁজুন।",
        "That's not it. Try again!": "এটি সঠিক চাল নয়। আবার চেষ্টা করুন!",
        "Incorrect move. Try again or click \"Show Hint\".": "ভুল চাল। আবার চেষ্টা করুন অথবা 'Show Hint'-এ ক্লিক করুন।",
        "Correct! Well done.": "সঠিক চাল! দারুণ খেলেছেন।",
        "Correct move! Well done finding the winning solution.": "সঠিক চাল! বিজয়ী কৌশলটি খুঁজে পাওয়ার জন্য দারুণ খেলেছেন।",
        "Good move! Waiting for opponent's response...": "ভালো চাল! প্রতিপক্ষের চালের জন্য অপেক্ষা করা হচ্ছে...",
        "Puzzle completed!": "ধাঁধা সফলভাবে সম্পন্ন হয়েছে!",
        "Puzzle completed! Excellent calculation and tactical precision.": "ধাঁধা সফলভাবে সম্পন্ন হয়েছে! অসাধারণ গণনা ও tactical নির্ভুলতা।",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "অসাধারণ চাল! আপনি সফলভাবে সঠিক কৌশলটি খুঁজে ধাঁধাটি সমাধান করেছেন।",
        "No more moves to show.": "দেখানোর মতো আর কোনো চাল নেই।"
    },
    'mr': {
        "Find the best move!": "सर्वोत्तम चाल शोधा!",
        "Your turn! Find the best move.": "तुमची पाळी! सर्वोत्तम चाल शोधा.",
        "Your turn! Find the next move.": "तुमची पाळी! पुढची चाल शोधा.",
        "That's not it. Try again!": "ही योग्य चाल नाही. पुन्हा प्रयत्न करा!",
        "Incorrect move. Try again or click \"Show Hint\".": "चुकीची चाल. पुन्हा प्रयत्न करा किंवा 'Show Hint' वर क्लिक करा.",
        "Correct! Well done.": "बरोबर चाल! खूप छान.",
        "Correct move! Well done finding the winning solution.": "बरोबर चाल! जिंकणारा तोडगा शोधल्याबद्दल खूप छान.",
        "Good move! Waiting for opponent's response...": "चांगली चाल! प्रतिस्पर्ध्याच्या उत्तराची वाट पाहत आहे...",
        "Puzzle completed!": "कोडे यशस्वीरीत्या पूर्ण झाले!",
        "Puzzle completed! Excellent calculation and tactical precision.": "कोडे यशस्वीरीत्या पूर्ण झाले! उत्कृष्ट गणना आणि tactical अचूकता.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "अप्रतिम खेळ! तुम्ही अचूक डावपेच शोधून कोडे यशस्वीरीत्या सोडवले आहे.",
        "No more moves to show.": "दाखवण्यासाठी आणखी चाली नाहीत."
    },
    'te': {
        "Find the best move!": "ఉత్తమ ఎత్తుగడను కనుగొనండి!",
        "Your turn! Find the best move.": "మీ వంతు! ఉత్తమ ఎత్తుగడను కనుగొనండి.",
        "Your turn! Find the next move.": "మీ వంతు! తర్వాతి ఎత్తుగడను కనుగొనండి.",
        "That's not it. Try again!": "ఇది సరైన ఎత్తుగడ కాదు. మళ్లీ ప్రయత్నించండి!",
        "Incorrect move. Try again or click \"Show Hint\".": "తప్పు ఎత్తుగడ. మళ్లీ ప్రయత్నించండి లేదా 'Show Hint' క్లిక్ చేయండి.",
        "Correct! Well done.": "సరైన ఎత్తుగడ! బాగా ఆడారు.",
        "Correct move! Well done finding the winning solution.": "సరైన ఎత్తుగడ! గెలుపు మార్గాన్ని కనుగొన్నందుకు అభినందనలు.",
        "Good move! Waiting for opponent's response...": "మంచి ఎత్తుగడ! ప్రత్యర్థి స్పందన కోసం వేచి చూస్తున్నాము...",
        "Puzzle completed!": "పజిల్ విజయవంతంగా పూర్తయింది!",
        "Puzzle completed! Excellent calculation and tactical precision.": "పజిల్ విజయవంతంగా పూర్తయింది! అద్భుతమైన గణన మరియు tactical ఖచ్చితత్వం.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "అద్భుతమైన ఆట! మీరు సరైన వ్యూహాన్ని కనుగొని పజిల్‌ను విజయవంతంగా పూర్తి చేశారు.",
        "No more moves to show.": "చూపించడానికి మరిన్ని ఎత్తుగడలు లేవు."
    },
    'kn': {
        "Find the best move!": "ಉತ್ತಮ ನಡೆಯನ್ನು ಹುಡುಕಿ!",
        "Your turn! Find the best move.": "ನಿಮ್ಮ ಸರದಿ! ಉತ್ತಮ ನಡೆಯನ್ನು ಹುಡುಕಿ.",
        "Your turn! Find the next move.": "ನಿಮ್ಮ ಸರದಿ! ಮುಂದಿನ ನಡೆಯನ್ನು ಹುಡುಕಿ.",
        "That's not it. Try again!": "ಇದು ಸರಿಯಾದ ನಡೆಯಲ್ಲ. ಪುನಃ ಪ್ರಯತ್ನಿಸಿ!",
        "Incorrect move. Try again or click \"Show Hint\".": "ತಪ್ಪಾದ ನಡೆ. ಪುನಃ ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ 'Show Hint' ಕ್ಲಿಕ್ ಮಾಡಿ.",
        "Correct! Well done.": "ಸರಿಯಾದ ನಡೆ! ಅದ್ಭುತವಾಗಿ ಆಡಿದ್ದೀರಿ.",
        "Correct move! Well done finding the winning solution.": "ಸರಿಯಾದ ನಡೆ! ಗೆಲುವಿನ ಮಾರ್ಗವನ್ನು ಕಂಡುಕೊಂಡಿದ್ದಕ್ಕೆ ಅಭಿನಂದನೆಗಳು.",
        "Good move! Waiting for opponent's response...": "ಉತ್ತಮ ನಡೆ! ಎದುರಾಳಿಯ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ...",
        "Puzzle completed!": "ಒಗಟು ಯಶಸ್ವಿಯಾಗಿ ಪೂರ್ಣಗೊಂಡಿದೆ!",
        "Puzzle completed! Excellent calculation and tactical precision.": "ಒಗಟು ಯಶಸ್ವಿಯಾಗಿ ಪೂರ್ಣಗೊಂಡಿದೆ! ಅತ್ಯುತ್ತಮ ಲೆಕ್ಕಾಚಾರ ಮತ್ತು tactical ನಿಖರತೆ.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "ಅದ್ಭುತ ಆಟ! ನೀವು ಸರಿಯಾದ ಯೋಜನೆಯನ್ನು ಕಂಡುಕೊಂಡು ಪಜಲ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪರಿಹರಿಸಿದ್ದೀರಿ.",
        "No more moves to show.": "ತೋರಿಸಲು ಯಾವುದೇ ಮುಂದಿನ ಚಲನೆಗಳಿಲ್ಲ."
    },
    'es': {
        "Find the best move!": "¡Encuentra la mejor jugada!",
        "Your turn! Find the best move.": "¡Tu turno! Encuentra la mejor jugada.",
        "Your turn! Find the next move.": "¡Tu turno! Encuentra la siguiente jugada.",
        "That's not it. Try again!": "Esa no es la jugada. ¡Inténtalo de nuevo!",
        "Incorrect move. Try again or click \"Show Hint\".": "Jugada incorrecta. Inténtalo de nuevo o pulsa 'Show Hint'.",
        "Correct! Well done.": "¡Correcto! Bien jugado.",
        "Correct move! Well done finding the winning solution.": "¡Jugada correcta! Bien hecho al encontrar la solución ganadora.",
        "Good move! Waiting for opponent's response...": "¡Buena jugada! Esperando la respuesta del rival...",
        "Puzzle completed!": "¡Problema completado con éxito!",
        "Puzzle completed! Excellent calculation and tactical precision.": "¡Problema completado con éxito! Excelente cálculo y precisión táctica.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "¡Brillante ejecución! Has completado la combinación ganadora y resuelto el problema con éxito.",
        "No more moves to show.": "No hay más jugadas para mostrar.",
        "Loading puzzles...": "",
        "Puzzle loaded. Computer will make the first move...": ""
    },
    'fr': {
        "Find the best move!": "Trouvez le meilleur coup!",
        "Your turn! Find the best move.": "À votre tour! Trouvez le meilleur coup.",
        "Your turn! Find the next move.": "À votre tour! Trouvez le coup suivant.",
        "That's not it. Try again!": "Ce n'est pas le bon coup. Réessayez!",
        "Incorrect move. Try again or click \"Show Hint\".": "Coup incorrect. Réessayez ou cliquez sur 'Show Hint'.",
        "Correct! Well done.": "Correct! Bien joué.",
        "Correct move! Well done finding the winning solution.": "Coup correct ! Bravo pour avoir trouvé la solution gagnante.",
        "Good move! Waiting for opponent's response...": "Bon coup! En attente de la réponse de l'adversaire...",
        "Puzzle completed!": "Problème résolu avec succès!",
        "Puzzle completed! Excellent calculation and tactical precision.": "Problème résolu avec succès ! Excellent calcul et précision tactique.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "Exécution brillante ! Vous avez trouvé la combinaison gagnante et résolu le problème.",
        "No more moves to show.": "Plus aucun coup à afficher.",
        "Loading puzzles...": "",
        "Puzzle loaded. Computer will make the first move...": ""
    },
    'de': {
        "Find the best move!": "Finde den besten Zug!",
        "Your turn! Find the best move.": "Du bist am Zug! Finde den besten Zug.",
        "Your turn! Find the next move.": "Du bist am Zug! Finde den nächsten Zug.",
        "That's not it. Try again!": "Das ist nicht der richtige Zug. Versuche es noch einmal!",
        "Incorrect move. Try again or click \"Show Hint\".": "Falscher Zug. Versuche es erneut oder klicke auf 'Show Hint'.",
        "Correct! Well done.": "Richtig! Gut gemacht.",
        "Correct move! Well done finding the winning solution.": "Richtiger Zug! Gut gemacht, die Gewinnlösung zu finden.",
        "Good move! Waiting for opponent's response...": "Guter Zug! Warte auf die Antwort des Gegners...",
        "Puzzle completed!": "Rätsel erfolgreich gelöst!",
        "Puzzle completed! Excellent calculation and tactical precision.": "Rätsel erfolgreich gelöst! Hervorragende Berechnung und taktische Präzision.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "Brillante Ausführung! Du hast die Gewinnkombination gefunden und das Schachrätsel gelöst.",
        "No more moves to show.": "Keine weiteren Züge anzuzeigen.",
        "Loading puzzles...": "",
        "Puzzle loaded. Computer will make the first move...": ""
    },
    'ru': {
        "Find the best move!": "Найдите лучший ход!",
        "Your turn! Find the best move.": "Ваш ход! Найдите лучший ход.",
        "Your turn! Find the next move.": "Ваш ход! Найдите следующий ход.",
        "That's not it. Try again!": "Это не тот ход. Попробуйте еще раз!",
        "Incorrect move. Try again or click \"Show Hint\".": "Неверный ход. Попробуйте снова или нажмите 'Show Hint'.",
        "Correct! Well done.": "Правильно! Отлично сыграно.",
        "Correct move! Well done finding the winning solution.": "Правильный ход! Отлично нашли победное решение.",
        "Good move! Waiting for opponent's response...": "Хороший ход! Ожидание ответа соперника...",
        "Puzzle completed!": "Задача успешно решена!",
        "Puzzle completed! Excellent calculation and tactical precision.": "Задача успешно решена! Отличный расчет и тактическая точность.",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "Блестящее исполнение! Вы успешно нашли победную комбинацию и решили задачу.",
        "No more moves to show.": "Больше нет ходов для показа.",
        "Loading puzzles...": "",
        "Puzzle loaded. Computer will make the first move...": ""
    },
    'zh': {
        "Find the best move!": "找到最佳走法！",
        "Your turn! Find the best move.": "轮到你了！找到最佳走法。",
        "Your turn! Find the next move.": "轮到你了！找到下一步走法。",
        "That's not it. Try again!": "走法不正确，请再试一次！",
        "Incorrect move. Try again or click \"Show Hint\".": "走法错误，请再试一次或点击 'Show Hint'。",
        "Correct! Well done.": "正确！走得漂亮。",
        "Correct move! Well done finding the winning solution.": "走法正确！成功找到制胜着法，走得漂亮。",
        "Good move! Waiting for opponent's response...": "走得好！等待对手的回应...",
        "Puzzle completed!": "谜题顺利完成！",
        "Puzzle completed! Excellent calculation and tactical precision.": "谜题顺利完成！出色的计算和战术精准度。",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "出色的发挥！你成功找到了制胜组合并解开了谜题。",
        "No more moves to show.": "没有更多走法可显示。",
        "Loading puzzles...": "",
        "Puzzle loaded. Computer will make the first move...": ""
    },
    'ja': {
        "Find the best move!": "最善の手を見つけましょう！",
        "Your turn! Find the best move.": "あなたの手番です！最善の手を見つけてください。",
        "Your turn! Find the next move.": "あなたの手番です！次の手を見つけましょう。",
        "That's not it. Try again!": "正解ではありません。もう一度試してください！",
        "Incorrect move. Try again or click \"Show Hint\".": "不正解です。再挑戦するか 'Show Hint' をクリックしてください。",
        "Correct! Well done.": "正解です！素晴らしい手です。",
        "Correct move! Well done finding the winning solution.": "正解です！見事に勝ち筋の解法を見つけました。",
        "Good move! Waiting for opponent's response...": "良い手です！相手の応答を待っています...",
        "Puzzle completed!": "パズルクリア！お見事です。",
        "Puzzle completed! Excellent calculation and tactical precision.": "パズルクリア！素晴らしい読みと戦術的な正確さです。",
        "Brilliant execution! You've successfully found the winning combination and solved the puzzle.": "見事な手筋です！勝ちのコンビネーションを発見し、パズルをクリアしました。",
        "No more moves to show.": "これ以上の手はありません。",
        "Loading puzzles...": "",
        "Puzzle loaded. Computer will make the first move...": ""
    }
};

const FEMALE_KEYWORDS = [
    'female', 'woman', 'femme', 'weiblich', 'donna', 'mujer', 'женский',
    'samantha', 'victoria', 'karen', 'moira', 'tessa', 'fiona', 'veena', 'heera', 'priya', 'tara', 
    'kathy', 'sandy', 'shelley', 'flo', 'grandma', 'zira', 'susan', 'ava', 'serena', 'zoe', 'jenny', 
    'aria', 'hazel', 'catherine', 'allison', 'google us english', 'google uk english female', 'lucia', 'sofia', 
    'camila', 'amelie', 'hannah', 'elena', 'sakura', 'aoi', 'xinyi', 'meiling', 'ekaterina', 'anna', 
    'giulia', 'chiara', 'ines', 'maryam', 'fatima', 'charlotte', 'lekha', 'neerja', 'swara', 'aditi',
    'shruti', 'tanvi', 'aarohi', 'sravani', 'spandana', 'maya', 'sarah', 'ananya', 'siri'
];

const MALE_KEYWORDS = [
    'male', 'man', 'homme', 'männlich', 'uomo', 'hombre', 'мужской',
    'rishi', 'aman', 'daniel', 'oliver', 'evan', 'nathan', 'tom', 'guy', 'aaron', 'lee', 'russell', 
    'george', 'arthur', 'david', 'mark', 'ravi', 'eric', 'christopher', 'james', 'brian', 'grandpa', 
    'google uk english male', 'carlos', 'mateo', 'henri', 'julien', 'klaus', 'lukas', 'dmitri', 
    'alexei', 'kenta', 'ren', 'zhiyuan', 'haoyu', 'rodrigo', 'lucas', 'marco', 'leonardo', 'tariq', 
    'youssef', 'jack', 'alex', 'fred', 'eklavya', 'marcus', 'reed', 'eddy', 'rocko'
];

const ROBOTIC_KEYWORDS = [
    'junior', 'ralph', 'albert', 'deranged', 'whisper', 'zarvox', 'trinoids', 
    'bad news', 'good news', 'bells', 'cellos', 'boing', 'organ', 'hysterical', 
    'compact', 'wobble', 'bubbles', 'jester', 'superstar', 'pipe organ'
];

export const isVoiceFemale = (v) => {
    if (!v) return false;
    const name = (v.name || '').toLowerCase();
    return FEMALE_KEYWORDS.some(k => name.includes(k));
};

export const isVoiceMale = (v) => {
    if (!v) return false;
    const name = (v.name || '').toLowerCase();
    if (FEMALE_KEYWORDS.some(k => name.includes(k))) return false;
    return MALE_KEYWORDS.some(k => name.includes(k));
};

export const isProUser = (user) => {
    let u = user;
    if (!u && typeof window !== 'undefined') {
        try {
            const rawUser = localStorage.getItem('user');
            if (rawUser) {
                u = JSON.parse(rawUser);
            }
        } catch (e) {}
    }
    if (!u) return false;
    if (u.is_admin) return true; // System admin override only
    if (u.ai_plan_expires_at) {
        try {
            if (new Date(u.ai_plan_expires_at) < new Date()) return false;
        } catch (err) {}
    }
    const aiPlan = (u.ai_subscription_plan || '').toLowerCase();
    // Strictly dedicated User AI 'pro' plan — coach/academy teaching plans do NOT grant AI Pro access
    return aiPlan === 'pro' || aiPlan === 'ai_pro';
};

export const canAccessVoice = (_voiceId, _user) => {
    // Voice check removed per user request - all available coach voices are accessible
    return true;
};

class CoachVoiceService {
    constructor() {
        this.synth = typeof window !== 'undefined' ? window.speechSynthesis : null;
        this.currentAudio = null;
        this.currentUtterance = null;
        this.isSpeaking = false;
        this.clientAudioCache = new Map();
        this.browserVoices = [];
        this.cloudTtsAvailable = null;
        this.dynamicVoices = null;
        this.dynamicRegionalCoaches = null;

        if (this.synth) {
            this.initBrowserVoices();
        }
        this.fetchDynamicVoices();
    }

    async fetchDynamicVoices() {
        try {
            const endpoint = API_CONFIG?.getUrl ? API_CONFIG.getUrl('/analyze/coach-voices') : (API_CONFIG?.BASE_URL || API_CONFIG?.baseURL || 'http://localhost:5025/api') + '/analyze/coach-voices';
            const res = await axios.get(endpoint, { timeout: 5000 });
            if (res.data?.success && Array.isArray(res.data.data) && res.data.data.length > 0) {
                this.dynamicVoices = res.data.data.filter(v => (v.gender || '').toLowerCase() !== 'female');
                if (res.data.regionalCoaches) {
                    const filteredReg = {};
                    Object.keys(res.data.regionalCoaches).forEach(k => {
                        filteredReg[k] = (res.data.regionalCoaches[k] || []).filter(v => (v.gender || '').toLowerCase() !== 'female');
                    });
                    this.dynamicRegionalCoaches = filteredReg;
                }
                if (typeof window !== 'undefined') {
                    const currentVoice = this.getUserVoice();
                    const allVoices = this.getAllVoices();
                    const voiceDef = allVoices.find(v => v.id === currentVoice) || allVoices[0];
                    window.dispatchEvent(new CustomEvent('ks_coach_voice_changed', {
                        detail: { voiceId: currentVoice, voiceDef, langCode: voiceDef?.langCode || 'en' }
                    }));
                }
            }
        } catch (e) {
            // Silently fallback to static ALL_COACH_VOICES
        }
    }

    initBrowserVoices() {
        if (!this.synth) return;
        const load = () => {
            const v = this.synth.getVoices();
            if (v && v.length > 0) {
                this.browserVoices = v;
            }
        };
        load();
        if (this.synth.onvoiceschanged !== undefined) {
            this.synth.onvoiceschanged = load;
        }
    }

    getBrowserVoicesList() {
        if (!this.synth) return [];
        const live = this.synth.getVoices();
        if (live && live.length > 0) {
            this.browserVoices = live;
        }
        return this.browserVoices || [];
    }

    getAllVoices() {
        const voices = this.dynamicVoices || ALL_COACH_VOICES;
        // Female voices removed for users
        return voices.filter(v => (v.gender || '').toLowerCase() !== 'female');
    }

    getRegions() {
        return SUPPORTED_REGIONS;
    }

    getUserRegion() {
        try {
            return localStorage.getItem('ks_coach_region') || 'IN';
        } catch (err) {
            return 'IN';
        }
    }

    setUserRegion(regionId) {
        try {
            localStorage.setItem('ks_coach_region', regionId);
            const coaches = this.getVoicesForRegion(regionId);
            if (coaches && coaches.length > 0) {
                this.setUserVoice(coaches[0].id);
            }
        } catch (e) {
            console.warn('[CoachVoice] Could not save region:', e);
        }
    }

    getVoicesForRegion(regionId) {
        const reg = regionId || this.getUserRegion();
        let list = [];
        if (this.dynamicRegionalCoaches && this.dynamicRegionalCoaches[reg]) {
            list = this.dynamicRegionalCoaches[reg];
        } else {
            list = REGIONAL_COACHES[reg] || REGIONAL_COACHES.IN;
        }
        // Female voices removed for users
        return list.filter(v => (v.gender || '').toLowerCase() !== 'female');
    }

    getUserVoice(user) {
        try {
            const currentRegion = this.getUserRegion();
            const allVoicesList = this.getAllVoices();
            const regionalList = this.getVoicesForRegion(currentRegion);
            const defaultVoice = regionalList[0] || allVoicesList[0] || { id: 'en-IN-Neural2-B' };
            const savedVoice = localStorage.getItem('ks_coach_voice') || defaultVoice.id;
            
            if (savedVoice === 'browser-en-US' || savedVoice === 'browser-en-us') {
                return 'en-US-Neural2-D';
            }

            // Check if saved voice is female or no longer available, fallback to male voice
            const voiceDef = allVoicesList.find(v => v.id === savedVoice);
            if (!voiceDef || (voiceDef.gender || '').toLowerCase() === 'female') {
                return defaultVoice.id;
            }

            return savedVoice;
        } catch (err) {
            return 'en-IN-Neural2-B';
        }
    }

    getCoachDavid() {
        return COACH_DAVID;
    }

    getCurrentCoachDetails(user) {
        const voiceId = this.getUserVoice(user);
        if (voiceId === 'en-US-Neural2-D' || voiceId === 'browser-en-US') {
            return COACH_DAVID;
        }
        const allVoicesList = this.getAllVoices();
        return allVoicesList.find(v => v.id === voiceId) || allVoicesList[0] || ALL_COACH_VOICES[0];
    }

    setUserVoice(voiceId) {
        try {
            localStorage.setItem('ks_coach_voice', voiceId);
            const allVoices = this.getAllVoices();
            const voiceDef = allVoices.find(v => v.id === voiceId) || ALL_COACH_VOICES.find(v => v.id === voiceId);
            if (voiceDef && voiceDef.region) {
                localStorage.setItem('ks_coach_region', voiceDef.region);
            }
            if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('ks_coach_voice_changed', { 
                    detail: { voiceId, voiceDef, langCode: voiceDef?.langCode || 'en' } 
                }));
            }
        } catch (e) {
            console.warn('[CoachVoice] Could not save user voice:', e);
        }
    }

    getAutoSpeak() {
        try {
            return localStorage.getItem('ks_coach_auto_speak') === 'true';
        } catch (err) {
            return false;
        }
    }

    setAutoSpeak(enabled) {
        try {
            localStorage.setItem('ks_coach_auto_speak', enabled ? 'true' : 'false');
        } catch (e) {
            console.warn('[CoachVoice] Could not save auto speak preference:', e);
        }
    }

    /**
     * Hydrate coach voice & narration preferences from backend user profile
     */
    syncFromUser(user) {
        if (!user) return;
        try {
            let changed = false;
            if (user.coach_voice) {
                localStorage.setItem('ks_coach_voice', user.coach_voice);
                changed = true;
            }
            if (user.coach_region) {
                localStorage.setItem('ks_coach_region', user.coach_region);
            }
            if (user.coach_auto_speak !== undefined && user.coach_auto_speak !== null) {
                localStorage.setItem('ks_coach_auto_speak', user.coach_auto_speak ? 'true' : 'false');
            }
            if (user.commentary_tier) {
                localStorage.setItem('ks_commentary_tier', user.commentary_tier);
            }
            if (changed && typeof window !== 'undefined') {
                const allVoices = this.getAllVoices();
                const voiceDef = allVoices.find(v => v.id === user.coach_voice) || ALL_COACH_VOICES.find(v => v.id === user.coach_voice);
                window.dispatchEvent(new CustomEvent('ks_coach_voice_changed', { 
                    detail: { voiceId: user.coach_voice, voiceDef, langCode: voiceDef?.langCode || 'en' } 
                }));
            }
        } catch (e) {
            console.warn('[CoachVoice] Could not sync preferences from user profile:', e);
        }
    }

    cleanChessTextForSpeech(text) {
        if (!text || typeof text !== 'string') return '';

        let cleaned = text;

        // 1. Remove markdown formatting, bold, italics, code blocks, headers
        cleaned = cleaned.replace(/```[a-z]*\n?/gi, '').replace(/```/g, '');
        cleaned = cleaned.replace(/\*\*/g, '').replace(/__/g, '').replace(/[*_]/g, '');
        cleaned = cleaned.replace(/^#+\s+/gm, '');
        cleaned = cleaned.replace(/^[-*•]\s+/gm, '');

        // 2. Strip raw parenthesized / bracketed engine evaluations (e.g. (+0.25), [-1.50], (cp: +30), (+M2))
        cleaned = cleaned.replace(/\(\s*[-+]?(?:\d+(?:\.\d+)?|M\d+)\s*\)/gi, '');
        cleaned = cleaned.replace(/\[\s*[-+]?(?:\d+(?:\.\d+)?|M\d+)\s*\]/gi, '');
        cleaned = cleaned.replace(/\b(?:eval|cp|evalDiff|playedEval|bestEval)\s*:\s*[-+]?\d+(?:\.\d+)?/gi, '');
        cleaned = cleaned.replace(/\b[-+]\d+\.\d{1,2}\b/g, ''); // Standalone raw eval floats like +0.25 or -1.40

        // 3. Move numbers like "1." or "1..." (Only at start of string or preceded by whitespace, NOT attached to square names like d4.)
        cleaned = cleaned.replace(/(?:^|\s)(\d+)\.\.\.\s*/g, ' Move $1, Black plays ');
        cleaned = cleaned.replace(/(?:^|\s)(\d+)\.\s+/g, ' Move $1, ');

        // 4. Spoken Castling
        cleaned = cleaned.replace(/\bO-O-O\b/g, 'Queenside Castles');
        cleaned = cleaned.replace(/\bO-O\b/g, 'Kingside Castles');

        // 5. Captures (SAN to natural words)
        cleaned = cleaned.replace(/\bN([a-h1-8])?x([a-h][1-8])/g, 'Knight takes $2');
        cleaned = cleaned.replace(/\bB([a-h1-8])?x([a-h][1-8])/g, 'Bishop takes $2');
        cleaned = cleaned.replace(/\bR([a-h1-8])?x([a-h][1-8])/g, 'Rook takes $2');
        cleaned = cleaned.replace(/\bQ([a-h1-8])?x([a-h][1-8])/g, 'Queen takes $2');
        cleaned = cleaned.replace(/\bK([a-h1-8])?x([a-h][1-8])/g, 'King takes $2');
        cleaned = cleaned.replace(/\b([a-h])x([a-h][1-8])/g, '$1 takes $2');

        // 6. Piece developments & moves
        cleaned = cleaned.replace(/\bN([a-h1-8])?([a-h][1-8])/g, 'Knight to $2');
        cleaned = cleaned.replace(/\bB([a-h1-8])?([a-h][1-8])/g, 'Bishop to $2');
        cleaned = cleaned.replace(/\bR([a-h1-8])?([a-h][1-8])/g, 'Rook to $2');
        cleaned = cleaned.replace(/\bQ([a-h1-8])?([a-h][1-8])/g, 'Queen to $2');
        cleaned = cleaned.replace(/\bK([a-h1-8])?([a-h][1-8])/g, 'King to $2');

        // 7. Checkmate and Check notation (only attached to chess moves/words)
        cleaned = cleaned.replace(/#(?!\w)/g, ' checkmate');
        cleaned = cleaned.replace(/([a-h1-8KRQBN])\+/g, '$1 check');
        cleaned = cleaned.replace(/\+/g, ' '); // Strip any remaining rogue plus signs

        // 8. Strip ALL emojis, symbols, and pictographs so TTS never speaks emoji names (e.g. "party popper", "party popat", "fire", etc.)
        cleaned = cleaned.replace(/[\u{1F000}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E0}-\u{1F1FF}\u{200D}]/gu, '');
        cleaned = cleaned.replace(/:[a-z0-9_+-]+:/gi, '');
        cleaned = cleaned.replace(/\b(?:party\s*popper|party\s*popat|party\s*poppat)\b/gi, '');
        cleaned = cleaned.replace(/(?:पार्टी\s*पॉपर|पार्टी\s*पोपट)/gi, '');

        return cleaned.replace(/\s+/g, ' ').trim();
    }

    findBrowserVoice(voiceId) {
        const voices = this.getBrowserVoicesList();
        if (!voices || voices.length === 0) return null;

        const allVoices = this.getAllVoices();
        const voiceDef = allVoices.find(v => v.id === voiceId) || ALL_COACH_VOICES.find(v => v.id === voiceId) || ALL_COACH_VOICES[0];
        const isTargetFemale = voiceDef?.gender === 'Female' || (voiceId && voiceId.toLowerCase().includes('female'));
        const isTargetMale = voiceDef?.gender === 'Male' || (voiceId && !voiceId.toLowerCase().includes('female') && voiceDef?.gender !== 'System');
        const targetLocale = (voiceDef?.langCode && voiceDef?.langCode !== 'local') ? voiceDef.langCode : '';
        const targetPrefix = targetLocale ? targetLocale.split('-')[0].toLowerCase() : '';

        const isRobotic = (v) => {
            const name = (v.name || '').toLowerCase();
            return ROBOTIC_KEYWORDS.some(k => name.includes(k));
        };

        const scoreVoice = (v) => {
            if (isRobotic(v)) return -1000;

            let score = 0;
            const name = (v.name || '').toLowerCase();
            const lang = (v.lang || '').replace('_', '-').toLowerCase();
            const normTargetLocale = targetLocale.toLowerCase();

            const isFemale = isVoiceFemale(v);
            const isMale = isVoiceMale(v);

            // Exact language and region (e.g. en-in, en-us, en-gb, hi-in, bn-in, mr-in, te-in, kn-in)
            if (normTargetLocale && lang === normTargetLocale) {
                score += 100;
            } else if (normTargetLocale && lang.startsWith(normTargetLocale)) {
                score += 80;
            } else if (targetPrefix && (lang === targetPrefix || lang.startsWith(targetPrefix + '-'))) {
                score += 60;
            } else if (targetPrefix && lang.startsWith(targetPrefix)) {
                score += 40;
            } else {
                score -= 80; // Language mismatch penalty
            }

            // Coach name matching in browser voice name
            const coachNameLower = (voiceDef?.name || '').toLowerCase().split(' ')[0];
            if (coachNameLower && name.includes(coachNameLower)) {
                score += 50;
            }

            // Gender alignment
            if (isTargetFemale) {
                if (isFemale) score += 50;
                else if (isMale) score -= 60;
            } else if (isTargetMale) {
                if (isMale) score += 50;
                else if (isFemale) score -= 60;
            }

            if (v.default && score > 0) score += 5;

            return score;
        };

        let bestVoice = null;
        let highestScore = -Infinity;

        for (const v of voices) {
            const score = scoreVoice(v);
            if (score > highestScore) {
                highestScore = score;
                bestVoice = v;
            }
        }

        if (bestVoice && highestScore > 0) {
            return bestVoice;
        }

        // Fallback: pick any non-robotic voice matching language prefix
        if (targetPrefix) {
            const langMatch = voices.find(v => (v.lang || '').toLowerCase().startsWith(targetPrefix) && !isRobotic(v));
            if (langMatch) return langMatch;
        }

        const nonRobotic = voices.filter(v => !isRobotic(v));
        return nonRobotic[0] || voices[0];
    }

    translateSync(text, targetLang) {
        if (!text || typeof text !== 'string') return '';
        const lang = targetLang || this.getCurrentCoachDetails()?.langCode || 'en';
        const langPrefix = (lang && lang !== 'local') ? lang.split('-')[0].toLowerCase() : 'en';

        if (langPrefix === 'en' || lang === 'local') return text;

        const trimmed = text.trim();

        // 0. Fast-path: If text is already in target Indic/non-English script, return as-is
        if (langPrefix === 'hi' && /[\u0900-\u097F]/.test(trimmed)) return trimmed;
        if (langPrefix === 'mr' && /[\u0900-\u097F]/.test(trimmed)) return trimmed;
        if (langPrefix === 'bn' && /[\u0980-\u09FF]/.test(trimmed)) return trimmed;
        if (langPrefix === 'te' && /[\u0C00-\u0C7F]/.test(trimmed)) return trimmed;
        if (langPrefix === 'kn' && /[\u0C80-\u0CFF]/.test(trimmed)) return trimmed;

        // 1. Direct phrasebook lookup (0ms instant)
        const book = INSTANT_CHESS_PHRASEBOOK[langPrefix];
        if (book && book[trimmed] !== undefined) {
            return book[trimmed];
        }

        // Classroom Welcome with batch: "Welcome to **{batch}**! The coach will share a puzzle soon."
        const welcomeBatchMatch = trimmed.match(/^Welcome to (?:\*\*)?(.+?)(?:\*\*)?! The coach will share a puzzle soon\.?$/i);
        if (welcomeBatchMatch) {
            const batch = welcomeBatchMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${batch}** में आपका स्वागत है! कोच जल्द ही एक पहेली साझा करेंगे।`;
                case 'bn': return `**${batch}**-এ আপনাকে স্বাগতম! কোচ শীঘ্রই একটি ধাঁধা শেয়ার করবেন।`;
                case 'mr': return `**${batch}** मध्ये आपले स्वागत आहे! कोच लवकरच एक कोडे शेअर करतील.`;
                case 'te': return `**${batch}** కి స్వాగతం! కోచ్ త్వరలోనే ఒక పజిల్‌ను షేర్ చేస్తారు.`;
                case 'kn': return `**${batch}** ಗೆ ಸುಸ್ವಾಗತ! ತರಬೇತುದಾರರು ಶೀಘ್ರದಲ್ಲೇ ಪಜಲ್ ಹಂಚಿಕೊಳ್ಳಲಿದ್ದಾರೆ.`;
                case 'es': return `¡Bienvenido a **${batch}**! El entrenador compartirá un problema pronto.`;
                case 'fr': return `Bienvenue dans **${batch}** ! L'entraîneur partagera bientôt un problème.`;
                case 'de': return `Willkommen bei **${batch}**! Der Trainer wird bald eine Aufgabe teilen.`;
                case 'ru': return `Добро пожаловать в **${batch}**! Тренер скоро поделится задачей.`;
                default: break;
            }
        }

        // Classroom Welcome short: "Welcome to **{batch}**!"
        const welcomeShortMatch = trimmed.match(/^Welcome to (?:\*\*)?(.+?)(?:\*\*)?!?$/i);
        if (welcomeShortMatch) {
            const batch = welcomeShortMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${batch}** में आपका स्वागत है!`;
                case 'bn': return `**${batch}**-এ আপনাকে স্বাগতম!`;
                case 'mr': return `**${batch}** मध्ये आपले स्वागत आहे!`;
                case 'te': return `**${batch}** కి స్వాగతం!`;
                case 'kn': return `**${batch}** ಗೆ ಸುಸ್ವಾಗತ!`;
                case 'es': return `¡Bienvenido a **${batch}**!`;
                case 'fr': return `Bienvenue dans **${batch}** !`;
                case 'de': return `Willkommen bei **${batch}**!`;
                case 'ru': return `Добро пожаловать в **${batch}**!`;
                default: break;
            }
        }

        // Classroom Welcome generic: "Welcome! The coach will share a puzzle soon."
        if (/^Welcome! The coach will share a puzzle soon\.?$/i.test(trimmed)) {
            switch (langPrefix) {
                case 'hi': return `स्वागत है! कोच जल्द ही एक पहेली साझा करेंगे।`;
                case 'bn': return `স্বাগতম! কোচ শীঘ্রই একটি ধাঁধা শেয়ার করবেন।`;
                case 'mr': return `स्वागत आहे! कोच लवकरच एक कोडे शेअर करतील.`;
                case 'te': return `స్వాగతం! కోచ్ త్వరలోనే ఒక పజిల్‌ను షేర్ చేస్తారు.`;
                case 'kn': return `ಸುಸ್ವಾಗತ! ತರಬೇತುದಾರರು ಶೀಘ್ರದಲ್ಲೇ ಪಜಲ್ ಹಂಚಿಕೊಳ್ಳಲಿದ್ದಾರೆ.`;
                case 'es': return `¡Bienvenido! El entrenador compartirá un problema pronto.`;
                case 'fr': return `Bienvenue ! L'entraîneur partagera bientôt un problème.`;
                case 'de': return `Willkommen! Der Trainer wird bald eine Aufgabe teilen.`;
                case 'ru': return `Добро пожаловать! Тренер скоро поделится задачей.`;
                default: break;
            }
        }

        // Classroom Coach generic: "Welcome! Set up a puzzle on the board to share with your students."
        if (/^Welcome! Set up a puzzle on the board to share with your students\.?$/i.test(trimmed)) {
            switch (langPrefix) {
                case 'hi': return `स्वागत है! अपने विद्यार्थियों के साथ साझा करने के लिए बोर्ड पर एक पहेली सेट करें।`;
                case 'bn': return `স্বাগতম! আপনার শিক্ষার্থীদের সাথে শেয়ার করতে বোর্ডে একটি ধাঁধা সেট করুন।`;
                case 'mr': return `स्वागत आहे! आपल्या विद्यार्थ्यांसह शेअर करण्यासाठी बोर्डवर एक कोडे सेट करा.`;
                case 'te': return `స్వాగతం! మీ విద్యార్థులతో షేర్ చేయడానికి బోర్డుపై ఒక పజిల్‌ను సెట్ చేయండి.`;
                case 'kn': return `ಸುಸ್ವಾಗತ! ನಿಮ್ಮ ವಿದ್ಯಾರ್ಥಿಗಳೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಲು ಬೋರ್ಡ್‌ನಲ್ಲಿ ಪಜಲ್ ಅನ್ನು ಹೊಂದಿಸಿ.`;
                case 'es': return `¡Bienvenido! Configura un problema en el tablero para compartirlo con tus alumnos.`;
                case 'fr': return `Bienvenue ! Configurez un problème sur l'échiquier pour le partager avec vos élèves.`;
                case 'de': return `Willkommen! Erstelle eine Aufgabe auf dem Brett, um sie mit deinen Schülern zu teilen.`;
                case 'ru': return `Добро пожаловать! Расставьте позицию на доске, чтобы поделиться задачей с учениками.`;
                default: break;
            }
        }

        // 2. Pattern Match: Quiet move "Standard opening preparation with **{move}**, developing piece harmony."
        const bookMatch = trimmed.match(/Standard opening preparation with \*\*(.+?)\*\*, developing piece harmony\./i);
        if (bookMatch) {
            const move = bookMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${move}** के साथ मानक opening तैयारी, pieces के समन्वय का विकास।`;
                case 'bn': return `**${move}** দিয়ে স্বাভাবিক opening প্রস্তুতি, pieces-এর সমন্বয় বৃদ্ধি।`;
                case 'mr': return `**${move}** सह मानक opening तयारी, pieces चा योग्य समन्वय.`;
                case 'te': return `**${move}** తో ప్రామాణిక opening సన్నాహం, pieces సమన్వయాన్ని పెంపొందించడం.`;
                case 'kn': return `**${move}** ನೊಂದಿಗೆ ಪ್ರಮಾಣಿತ opening ಸಿದ್ಧತೆ, pieces ಸಮನ್ವಯವನ್ನು ಹೆಚ್ಚಿಸುವುದು.`;
                case 'es': return `Preparación estándar de apertura con **${move}**, desarrollando la armonía de las pieces.`;
                case 'fr': return `Préparation d'ouverture standard avec **${move}**, développant l'harmonie des pieces.`;
                case 'de': return `Standard-Eröffnungsvorbereitung mit **${move}**, entwickelt die Harmonie der pieces.`;
                case 'ru': return `Стандартная дебютная подготовка с **${move}**, развивающая гармонию pieces.`;
                default: break;
            }
        }

        // 3. Pattern Match: Quiet move "Plays **{move}**, maintaining the position and piece coordination."
        const playMatch = trimmed.match(/Plays \*\*(.+?)\*\*, maintaining the position and piece coordination\./i);
        if (playMatch) {
            const move = playMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${move}** खेलकर स्थिति और pieces के तालमेल को बनाए रखा।`;
                case 'bn': return `**${move}** খেলে পজিশন ও pieces-এর সমন্বয় ধরে রাখা হলো।`;
                case 'mr': return `**${move}** खेळून स्थिती आणि pieces चा ताळमेळ राखला.`;
                case 'te': return `**${move}** ఆడి పొజిషన్ మరియు pieces సమన్వయాన్ని కొనసాగించారు.`;
                case 'kn': return `**${move}** ಆಡಿ ಸ್ಥಾನ ಮತ್ತು pieces ಸಮನ್ವಯವನ್ನು ಕಾಪಾಡಿಕೊಳ್ಳಲಾಗಿದೆ.`;
                case 'es': return `Juega **${move}**, manteniendo la posición y la coordinación de las pieces.`;
                case 'fr': return `Joue **${move}**, maintenant la position et la coordination des pieces.`;
                case 'de': return `Spielt **${move}**, hält die Stellung und die Koordination der pieces aufrecht.`;
                case 'ru': return `Играет **${move}**, поддерживая позицию и координацию pieces.`;
                default: break;
            }
        }

        // 4. Pattern Match: Quiet move "Strong, precise play with **{move}**, enhancing positional control."
        const strongMatch = trimmed.match(/Strong, precise play with \*\*(.+?)\*\*, enhancing positional control\./i);
        if (strongMatch) {
            const move = strongMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${move}** के साथ मजबूत और सटीक खेल, स्थिति पर नियंत्रण बढ़ाया।`;
                case 'bn': return `**${move}** দিয়ে শক্তিশালী ও নিখুঁত চাল, অবস্থানের নিয়ন্ত্রণ বৃদ্ধি পেল।`;
                case 'mr': return `**${move}** सह भक्कम आणि अचूक खेळ, स्थितीवरील नियंत्रण वाढवले.`;
                case 'te': return `**${move}** తో బలమైన, ఖచ్చితమైన ఆట, పొజిషన్‌పై నియంత్రణను పెంచింది.`;
                case 'kn': return `**${move}** ನೊಂದಿಗೆ ಬಲವಾದ, ನಿಖರವಾದ ಆಟ, ಸ್ಥಾನದ ಮೇಲಿನ ನಿಯಂತ್ರಣವನ್ನು ಹೆಚ್ಚಿಸಿದೆ.`;
                case 'es': return `Juego sólido y preciso con **${move}**, mejorando el control posicional.`;
                case 'fr': return `Jeu solide et précis avec **${move}**, renforçant le contrôle positionnel.`;
                case 'de': return `Starkes, präzises Spiel mit **${move}**, verbessert die positionelle Kontrolle.`;
                default: break;
            }
        }

        // 5. Pattern Match: Castles
        if (/Castles to tuck the king into safety and activate the rook\./i.test(trimmed)) {
            switch (langPrefix) {
                case 'hi': return `King को सुरक्षित करने और Rook को सक्रिय करने के लिए Castling की।`;
                case 'bn': return `King-কে সুরক্ষিত করতে এবং Rook-কে সক্রিয় করতে Castling করা হলো।`;
                case 'mr': return `King ला सुरक्षित करण्यासाठी आणि Rook ला सक्रिय करण्यासाठी Castling केली.`;
                case 'te': return `King ను సురక్షితంగా ఉంచడానికి మరియు Rook ను చురుకుగా చేయడానికి Castling చేశారు.`;
                case 'kn': return `King ಅನ್ನು ಸುರಕ್ಷಿತವಾಗಿರಿಸಲು ಮತ್ತು Rook ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲು Castling ಮಾಡಲಾಯಿತು.`;
                case 'es': return `Enroque para resguardar al King y activar la Rook.`;
                case 'fr': return `Roque pour mettre le King à l'abri et activer la Rook.`;
                case 'de': return `Rochiert, um den King in Sicherheit zu bringen und den Rook zu aktivieren.`;
                default: break;
            }
        }

        // 6. Pattern Match: Checkmate
        const mateMatch = trimmed.match(/Delivers checkmate on the board with \*\*(.+?)\*\*!/i);
        if (mateMatch) {
            const move = mateMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${move}** के साथ बोर्ड पर सीधा Checkmate दिया!`;
                case 'bn': return `**${move}** দিয়ে বোর্ডে সরাসরি Checkmate দেওয়া হলো!`;
                case 'mr': return `**${move}** सह पटावर थेट Checkmate दिला!`;
                case 'te': return `**${move}** తో బోర్డుపై ప్రత్యక్ష Checkmate సాధించారు!`;
                case 'kn': return `**${move}** ನೊಂದಿಗೆ ಬೋರ್ಡ್‌ನಲ್ಲಿ ನೇರ Checkmate ನೀಡಲಾಯಿತು!`;
                case 'es': return `¡Da Checkmate en el tablero con **${move}**!`;
                case 'fr': return `Inflige Checkmate sur l'échiquier avec **${move}** !`;
                case 'de': return `Setzt mit **${move}** Checkmate auf dem Brett!`;
                default: break;
            }
        }

        // 7. Pattern Match: Tactical sequence continuation
        const seqMatch = trimmed.match(/Plays \*\*(.+?)\*\*, advancing the winning tactical sequence\./i);
        if (seqMatch) {
            const move = seqMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${move}** चला, जीतने वाले tactical क्रम को आगे बढ़ाया।`;
                case 'bn': return `**${move}** দিয়ে চাল, যা জয়ী tactical ধারাকে এগিয়ে নিল।`;
                case 'mr': return `**${move}** चाल खेळली, जिंकणाऱ्या tactical क्रमाला पुढे नेले.`;
                case 'te': return `**${move}** ఆడారు, విజయవంతమైన tactical క్రమాన్ని ముందుకు తీసుకెళ్లారు.`;
                case 'kn': return `**${move}** ಆಡಲಾಯಿತು, ಗೆಲುವಿನ tactical ಅನುಕ್ರಮವನ್ನು ಮುಂದುವರಿಸಿದೆ.`;
                case 'es': return `Juega **${move}**, avanzando la secuencia táctica ganadora.`;
                case 'fr': return `Joue **${move}**, faisant progresser la séquence tactique gagnante.`;
                case 'de': return `Spielt **${move}**, setzt die gewinnbringende taktische Sequenz fort.`;
                default: break;
            }
        }

        // 8. Pattern Match: "Computer played {move}. You are playing as {color}."
        const compRegex = /Computer played (.+?)\. You are playing as (White|Black)\.?(?: Find the best move!?)?/i;
        const match = trimmed.match(compRegex);
        if (match) {
            const move = match[1];
            const color = match[2];
            switch (langPrefix) {
                case 'hi': return `Computer ने **${move}** चला। आप ${color} खेल रहे हैं। सर्वोत्तम चाल खोजें!`;
                case 'bn': return `Computer **${move}** চাল দিয়েছে। আপনি ${color} খেলছেন। সেরা চালটি খুঁজুন!`;
                case 'mr': return `Computer ने **${move}** चाल खेळली. तुम्ही ${color} खेळत आहात. सर्वोत्तम चाल शोधा!`;
                case 'te': return `Computer **${move}** ఆడింది. మీరు ${color} గా ఆడుతున్నారు. ఉత్తమ ఎత్తుగడను కనుగొనండి!`;
                case 'kn': return `Computer **${move}** ಚಲಿಸಿದೆ. ನೀವು ${color} ಆಗಿ ಆಡುತ್ತಿದ್ದೀರಿ. ಉತ್ತಮ ನಡೆಯನ್ನು ಹುಡುಕಿ!`;
                case 'es': return `El ordenador jugó **${move}**. Juegas con ${color}. ¡Encuentra la mejor jugada!`;
                case 'fr': return `L'ordinateur a joué **${move}**. Vous jouez ${color}. Trouvez le meilleur coup !`;
                case 'de': return `Computer spielte **${move}**. Du spielst mit ${color}. Finde den besten Zug!`;
                case 'ru': return `Компьютер сыграл **${move}**. Вы играете за ${color}.`;
                case 'zh': return `电脑走了 **${move}**。你执 ${color}。`;
                case 'ja': return `コンピュータが **${move}** を指しました。あなたは ${color} です。`;
                default: break;
            }
        }

        // 9. Pattern Match: "Opponent played **{move}**. Puzzle completed! Excellent calculation and tactical precision."
        const oppCompleteMatch = trimmed.match(/Opponent played \*\*(.+?)\*\*\. Puzzle completed! Excellent calculation and tactical precision\./i);
        if (oppCompleteMatch) {
            const m = oppCompleteMatch[1];
            switch (langPrefix) {
                case 'hi': return `प्रतिद्वंद्वी ने **${m}** खेला। पहेली सफलतापूर्वक पूरी हुई! उत्कृष्ट गणना और tactical सटीकता।`;
                case 'bn': return `প্রতিপক্ষ **${m}** খেলেছে। ধাঁধা সফলভাবে সম্পন্ন হয়েছে! অসাধারণ গণনা ও tactical নির্ভুলতা।`;
                case 'mr': return `प्रतिस्पर्ध्याने **${m}** चाल खेळली. कोडे यशस्वीरीत्या पूर्ण झाले! उत्कृष्ट गणना आणि tactical अचूकता.`;
                case 'te': return `ప్రత్యర్థి **${m}** ఆడారు. పజిల్ విజయవంతంగా పూర్తయింది! అద్భుతమైన గణన మరియు tactical ఖచ్చితత్వం.`;
                case 'kn': return `ಎದುರಾಳಿ **${m}** ಆಡಿದ್ದಾರೆ. ಒಗಟು ಯಶಸ್ವಿಯಾಗಿ ಪೂರ್ಣಗೊಂಡಿದೆ! ಅತ್ಯುತ್ತಮ ಲೆಕ್ಕಾಚಾರ ಮತ್ತು tactical ನಿಖರತೆ.`;
                case 'es': return `El oponente jugó **${m}**. ¡Problema completado con éxito! Excelente cálculo y precisión táctica.`;
                case 'fr': return `L'adversaire a joué **${m}**. Problème résolu avec succès ! Excellent calcul et précision tactique.`;
                case 'de': return `Der Gegner spielte **${m}**. Rätsel erfolgreich gelöst! Hervorragende Berechnung und taktische Präzision.`;
                case 'ru': return `Соперник сыграл **${m}**. Задача успешно решена! Отличный расчет и тактическая точность.`;
                case 'zh': return `对手走了 **${m}**。谜题顺利完成！出色的计算和战术精准度。`;
                case 'ja': return `相手は **${m}** を指しました。パズルクリア！素晴らしい読みと戦術的な正確さです。`;
                default: break;
            }
        }

        // 10. Pattern Match: "Opponent responded with **{move}**. Your turn! Find the continuation."
        const oppContinueMatch = trimmed.match(/Opponent responded with \*\*(.+?)\*\*\. Your turn! Find the continuation\./i);
        if (oppContinueMatch) {
            const m = oppContinueMatch[1];
            switch (langPrefix) {
                case 'hi': return `प्रतिद्वंद्वी ने **${m}** का जवाब दिया। आपकी बारी! अगली चाल खोजें।`;
                case 'bn': return `প্রতিপক্ষ **${m}** দিয়ে জবাব দিল। আপনার পালা! পরবর্তী চালটি খুঁজুন।`;
                case 'mr': return `प्रतिस्पर्ध्याने **${m}** चाल खेळली. तुमची पाळी! पुढची चाल शोधा.`;
                case 'te': return `ప్రత్యర్థి **${m}** తో స్పందించారు. మీ వంతు! తర్వాతి ఎత్తుగడను కనుగొనండి.`;
                case 'kn': return `ಎದುರಾಳಿ **${m}** ನೊಂದಿಗೆ ಉತ್ತರಿಸಿದ್ದಾರೆ. ನಿಮ್ಮ ಸರದಿ! ಮುಂದಿನ ನಡೆಯನ್ನು ಹುಡುಕಿ.`;
                case 'es': return `El oponente respondió con **${m}**. ¡Tu turno! Encuentra la continuación.`;
                case 'fr': return `L'adversaire a répondu avec **${m}**. À votre tour ! Trouvez la suite.`;
                case 'de': return `Der Gegner antwortete mit **${m}**. Du bist am Zug! Finde die Fortsetzung.`;
                case 'ru': return `Соперник ответил **${m}**. Ваш ход! Найдите продолжение.`;
                case 'zh': return `对手回应了 **${m}**。轮到你了！找到后续走法。`;
                case 'ja': return `相手は **${m}** と応手を打ちました。あなたの手番です！次の手を見つけましょう。`;
                default: break;
            }
        }

        // 11. Pattern Match: "Correct move with **{move}**! Well done finding the winning solution."
        const correctMoveMatch = trimmed.match(/Correct move with \*\*(.+?)\*\*! Well done finding the winning solution\./i);
        if (correctMoveMatch) {
            const m = correctMoveMatch[1];
            switch (langPrefix) {
                case 'hi': return `**${m}** के साथ सही चाल! जीतने वाला समाधान खोजने के लिए बहुत बढ़िया।`;
                case 'bn': return `**${m}** দিয়ে সঠিক চাল! বিজয়ী কৌশলটি খুঁজে পাওয়ার জন্য দারুণ খেলেছেন।`;
                case 'mr': return `**${m}** सह बरोबर चाल! जिंकणारा तोडगा शोधल्याबद्दल खूप छान.`;
                case 'te': return `**${m}** తో సరైన ఎత్తుగడ! గెలుపు మార్గాన్ని కనుగొన్నందుకు అభినందనలు.`;
                case 'kn': return `**${m}** ನೊಂದಿಗೆ ಸರಿಯಾದ ನಡೆ! ಗೆಲುವಿನ ಮಾರ್ಗವನ್ನು ಕಂಡುಕೊಂಡಿದ್ದಕ್ಕೆ ಅಭಿನಂದನೆಗಳು.`;
                case 'es': return `¡Jugada correcta con **${m}**! Bien hecho al encontrar la solución ganadora.`;
                case 'fr': return `Coup correct avec **${m}** ! Bravo pour avoir trouvé la solution gagnante.`;
                case 'de': return `Richtiger Zug mit **${m}**! Gut gemacht, die Gewinnlösung zu finden.`;
                case 'ru': return `Правильный ход **${m}**! Отлично нашли победное решение.`;
                case 'zh': return `**${m}** 走得正确！成功找到制胜着法，走得漂亮。`;
                case 'ja': return `**${m}** で正解です！見事に勝ち筋の解法を見つけました。`;
                default: break;
            }
        }

        // 12. Pattern Match: "{oppNotation}Your turn! Find the next move."
        if (trimmed.includes('Your turn! Find the next move.')) {
            const prefix = trimmed.replace('Your turn! Find the next move.', '').trim();
            switch (langPrefix) {
                case 'hi': return `${prefix ? prefix + ' ' : ''}आपकी बारी! अगली चाल खोजें।`;
                case 'bn': return `${prefix ? prefix + ' ' : ''}আপনার পালা! পরবর্তী চালটি খুঁজুন।`;
                case 'mr': return `${prefix ? prefix + ' ' : ''}तुमची पाळी! पुढची चाल शोधा.`;
                case 'te': return `${prefix ? prefix + ' ' : ''}మీ వంతు! తర్వాతి ఎత్తుగడను కనుగొనండి.`;
                case 'kn': return `${prefix ? prefix + ' ' : ''}ನಿಮ್ಮ ಸರದಿ! ಮುಂದಿನ ನಡೆಯನ್ನು ಹುಡುಕಿ.`;
                case 'es': return `${prefix ? prefix + ' ' : ''}¡Tu turno! Encuentra la siguiente jugada.`;
                case 'fr': return `${prefix ? prefix + ' ' : ''}À votre tour! Trouvez le coup suivant.`;
                case 'de': return `${prefix ? prefix + ' ' : ''}Du bist am Zug! Finde den nächsten Zug.`;
                case 'ru': return `${prefix ? prefix + ' ' : ''}Ваш ход! Найдите следующий ход.`;
                case 'zh': return `${prefix ? prefix + ' ' : ''}轮到你了！找到下一步走法。`;
                case 'ja': return `${prefix ? prefix + ' ' : ''}あなたの手番です！次の手を見つけましょう。`;
                default: break;
            }
        }

        // 13. Pattern Match: "Hello! Here I am present with your **Daily Puzzle**. You have to play with **{color}** — find the best continuation!"
        const dailyGreetingMatch = trimmed.match(/Hello! Here I am present with your \*\*Daily Puzzle\*\*\. You have to play with \*\*(.+?)\*\* — find the best continuation!/i);
        if (dailyGreetingMatch) {
            const c = dailyGreetingMatch[1];
            switch (langPrefix) {
                case 'hi': return `नमस्ते! मैं आपकी **Daily Puzzle** के साथ उपस्थित हूँ। आपको **${c === 'White' ? 'सफेद' : 'काले'}** मोहरों से खेलना है — सर्वोत्तम निरंतरता खोजें!`;
                case 'bn': return `নমস্কার! আমি আপনার **Daily Puzzle** নিয়ে এসেছি। আপনাকে **${c === 'White' ? 'সাদা' : 'কালো'}** ঘুঁটি নিয়ে খেলতে হবে — সেরা চালটি খুঁজুন!`;
                case 'mr': return `नमस्कार! मी तुमच्या **Daily Puzzle** सह उपस्थित आहे. तुम्हाला **${c === 'White' ? 'पांढऱ्या' : 'काळ्या'}** मोहऱ्यांनी खेळायचे आहे — सर्वोत्तम चाल शोधा!`;
                case 'es': return `¡Hola! Aquí estoy con tu **Daily Puzzle**. Te toca jugar con **${c === 'White' ? 'Blancas' : 'Negras'}** — ¡encuentra la mejor continuación!`;
                default: break;
            }
        }

        // 10. Memory & LocalStorage Cache Lookup (0ms instant)
        const cacheKey = `trans_${langPrefix}_${trimmed}`;
        if (this.clientAudioCache && this.clientAudioCache.has(cacheKey)) {
            return this.clientAudioCache.get(cacheKey);
        }

        return text;
    }

    async translateCommentary(text, targetLang) {
        if (!text || typeof text !== 'string') return '';
        const lang = targetLang || this.getCurrentCoachDetails()?.langCode || 'en';
        const langPrefix = (lang && lang !== 'local') ? lang.split('-')[0].toLowerCase() : 'en';
        
        const isNonEnglishText = /[\u0900-\u097F\u0980-\u09FF\u0C00-\u0C7F\u0C80-\u0CFF\u4E00-\u9FFF\u3040-\u309F\u0400-\u04FF\u00C0-\u00FF]/.test(text);

        if ((langPrefix === 'en' || lang === 'local') && !isNonEnglishText) {
            return text;
        }

        // 1. Try instant sync phrasebook / pattern / cache first (0ms, 0 network, 0 LLM calls)
        const instant = this.translateSync(text, langPrefix);
        if (instant !== text) {
            return instant;
        }

        const cacheKey = `trans_${langPrefix}_${text.trim()}`;
        if (!this.clientAudioCache) {
            this.clientAudioCache = new Map();
        }

        if (this.clientAudioCache.has(cacheKey)) {
            return this.clientAudioCache.get(cacheKey);
        }

        // 2. Deduplicate in-flight translation promises
        this._inFlightTranslations = this._inFlightTranslations || new Map();
        if (this._inFlightTranslations.has(cacheKey)) {
            return this._inFlightTranslations.get(cacheKey);
        }

        const translationPromise = (async () => {
            try {
                const endpoint = API_CONFIG?.getUrl ? API_CONFIG.getUrl('/analyze/translate-commentary') : (API_CONFIG?.BASE_URL || API_CONFIG?.baseURL || 'http://localhost:5025/api') + '/analyze/translate-commentary';
                const res = await axios.post(endpoint, {
                    text,
                    targetLanguage: langPrefix
                }, {
                    headers: API_CONFIG?.getHeaders ? API_CONFIG.getHeaders(true) : { 'Content-Type': 'application/json' },
                    timeout: 10000
                });

                if (res && res.data && res.data.success && res.data.translatedText) {
                    let resultText = res.data.translatedText
                        .replace(/^["'`]+|["'`]+$/g, '')
                        .replace(/```[a-z]*\n?/gi, '').replace(/```/g, '')
                        .replace(/^\s*(?:\*\*)?(?:Here(?:\s+is|\s*'s|\s+are)\s+(?:the\s+)?(?:direct\s+)?(?:translation|translated\s+text)[^:\n]*|Translation(?:\s+to\s+[a-zA-Z\s]+)?|Translated(?:\s+text)?(?:\s+to\s+[a-zA-Z\s]+)?|to\s+[a-zA-Z]+|पुनरावृत्ति|अनुकृति|अनुवाद)(?:\*\*)?\s*:\s*(?:\*\*(?!\w))?\s*/im, '')
                        .replace(/^[\s*_#-]*(?:Coach(?:'s)?\s+Commentary|Explanation|Analysis|Coach)\s*:\s*/im, '')
                        .replace(/^[\s•\-–—]+/, '')
                        .replace(/^\*(?!\*)\s+/, '')
                        .trim();

                    const starCount = (resultText.match(/\*\*/g) || []).length;
                    if (starCount % 2 !== 0) {
                        resultText = resultText.replace(/\*\*/, '');
                    }

                    this.clientAudioCache.set(cacheKey, resultText);
                    return resultText;
                }
            } catch (e) {
                console.warn('[CoachVoice] Translation API unavailable:', e.message);
            }
            return text;
        })().finally(() => {
            if (this._inFlightTranslations) {
                this._inFlightTranslations.delete(cacheKey);
            }
        });

        this._inFlightTranslations.set(cacheKey, translationPromise);
        return translationPromise;
    }

    async speak(text, { voiceName, voiceId, pitch, speakingRate, audioUrl, onStart, onEnd, onError, isPreview = false, isDailyPuzzle = false } = {}) {
        if (!text || typeof text !== 'string') {
            this.stop();
            return false;
        }

        // IMMEDIATELY halt any active or queued speech/audio from prior moves
        this.stop();

        this.speakSessionId = (this.speakSessionId || 0) + 1;
        const currentSession = this.speakSessionId;
        this.activeAbortController = new AbortController();
        const signal = this.activeAbortController.signal;

        const chosenVoiceId = voiceName || voiceId || this.getUserVoice();
        const allVoices = this.getAllVoices();
        const voiceDef = allVoices.find(v => v.id === chosenVoiceId) || ALL_COACH_VOICES.find(v => v.id === chosenVoiceId) || allVoices[0] || ALL_COACH_VOICES[0];
        const langCode = voiceDef?.langCode || 'en-US';
        const langPrefix = (langCode && langCode !== 'local') ? langCode.split('-')[0].toLowerCase() : 'en';

        // 1. Direct audio URL playback (e.g. from puzzle commentary or preloaded sound)
        if (audioUrl && typeof audioUrl === 'string' && audioUrl.startsWith('http')) {
            return this.playAudioUrl(audioUrl, {
                onStart,
                onEnd,
                onError,
                chosenVoiceId,
                pitch,
                speakingRate
            });
        }

        // 2. Pre-clean text to strip emojis/symbols BEFORE translation (avoids translating emojis to words like "party popper")
        let speechText = this.cleanChessTextForSpeech(text);

        // 3. If not preview and coach is non-English, translate text preserving piece names
        if (!isPreview && langPrefix !== 'en' && langCode !== 'local') {
            speechText = await this.translateCommentary(speechText, langPrefix);
            if (this.speakSessionId !== currentSession || signal.aborted) {
                return false;
            }
        }

        speechText = this.cleanChessTextForSpeech(speechText);
        if (!speechText || this.speakSessionId !== currentSession || signal.aborted) return false;

        const isFree = voiceDef?.tier === 'free' || chosenVoiceId.startsWith('browser-');
        const voicePitch = pitch !== undefined ? parseFloat(pitch) : (parseFloat(voiceDef?.voicePitch || voiceDef?.voice_pitch) || 0.0);
        const voiceRate = speakingRate !== undefined ? parseFloat(speakingRate) : (parseFloat(voiceDef?.speakingRate || voiceDef?.speaking_rate) || 1.0);

        // 3. Free In-Browser Voice: Free/device synthesizer audio removed per user request
        if (isFree) {
            return false;
        }

        const cacheKey = `${chosenVoiceId}_${speechText}_${voicePitch}_${voiceRate}`;

        // 4. Check in-memory audio cache
        if (this.clientAudioCache.has(cacheKey)) {
            if (this.speakSessionId !== currentSession || signal.aborted) return false;
            const cachedData = this.clientAudioCache.get(cacheKey);
            if (typeof cachedData === 'string' && cachedData.startsWith('http')) {
                return this.playAudioUrl(cachedData, { onStart, onEnd, onError, chosenVoiceId, pitch: voicePitch, speakingRate: voiceRate });
            }
            return this.playBase64Audio(cachedData, { onStart, onEnd, onError, chosenVoiceId, pitch: voicePitch, speakingRate: voiceRate });
        }

        // 5. If cloud TTS is known to be unconfigured or disabled, do not fall back to local system speech
        if (this.cloudTtsAvailable === false) {
            if (this.speakSessionId !== currentSession || signal.aborted) return false;
            if (onError) onError(new Error('Cloud TTS is unavailable'));
            return false;
        }

        // 6. Try Google Cloud Text-to-Speech (Neural2 Tier)
        try {
            const payload = { 
                text: speechText,
                voiceName: chosenVoiceId,
                pitch: voicePitch,
                speakingRate: voiceRate,
                languageCode: langCode,
                langCode,
                isPreview: Boolean(isPreview || speechText.length < 150),
                isDailyPuzzle: Boolean(isDailyPuzzle || chosenVoiceId === 'en-US-Neural2-D')
            };

            const endpoint = API_CONFIG?.getUrl ? API_CONFIG.getUrl('/analyze/coach-voice') : (API_CONFIG?.BASE_URL || API_CONFIG?.baseURL || 'http://localhost:5025/api') + '/analyze/coach-voice';
            const res = await axios.post(endpoint, payload, {
                headers: API_CONFIG?.getHeaders ? API_CONFIG.getHeaders(true) : { 'Content-Type': 'application/json' },
                timeout: 12000,
                signal
            });

            if (this.speakSessionId !== currentSession || signal.aborted) return false;

            if (res && res.data && res.data.success) {
                // Prioritize CDN Edge URL over heavy base64 strings
                if (res.data.audioUrl) {
                    this.cloudTtsAvailable = true;
                    this.clientAudioCache.set(cacheKey, res.data.audioUrl);
                    return this.playAudioUrl(res.data.audioUrl, { onStart, onEnd, onError, chosenVoiceId, pitch: voicePitch, speakingRate: voiceRate });
                } else if (res.data.audioBase64) {
                    this.cloudTtsAvailable = true;
                    const base64Data = res.data.audioBase64;
                    this.clientAudioCache.set(cacheKey, base64Data);
                    return this.playBase64Audio(base64Data, { onStart, onEnd, onError, chosenVoiceId, pitch: voicePitch, speakingRate: voiceRate });
                }
            } else if (res && res.data && (res.data.fallback || !res.data.success)) {
                // Latch cloudTtsAvailable = false if backend disabled/unconfigured/unauthorized
                this.cloudTtsAvailable = false;
            }
        } catch (cloudErr) {
            if (axios.isCancel(cloudErr) || cloudErr.name === 'CanceledError' || cloudErr.name === 'AbortError') {
                return false;
            }
            if (cloudErr.response?.status === 403 || cloudErr.response?.status === 401 || cloudErr.response?.data?.requiresPro) {
                this.cloudTtsAvailable = false;
            }
            console.warn('[CoachVoice] Cloud TTS error:', cloudErr.message);
            if (onError) onError(cloudErr);
            return false;
        }

        if (this.speakSessionId !== currentSession || signal.aborted) return false;

        // No fallback to local device/browser Web Speech API
        if (onError) onError(new Error('Cloud audio playback unavailable'));
        return false;
    }

    initAudioContext() {
        if (typeof window === 'undefined') return null;
        if (!this.audioCtx) {
            const AudioContextClass = window.AudioContext || window.webkitAudioContext;
            if (AudioContextClass) {
                this.audioCtx = new AudioContextClass();
            }
        }
        if (this.audioCtx && this.audioCtx.state === 'suspended') {
            this.audioCtx.resume().catch(() => {});
        }
        return this.audioCtx;
    }

    startAudioAnalysis(audioElement, voiceId) {
        this.stopAudioAnalysis();
        if (!audioElement || typeof window === 'undefined') return;

        try {
            const ctx = this.initAudioContext();
            if (!ctx) {
                this.startSimulatedAnalysis(voiceId);
                return;
            }

            if (!this.analyser) {
                this.analyser = ctx.createAnalyser();
                this.analyser.fftSize = 256;
                this.analyser.smoothingTimeConstant = 0.55;
            }

            try {
                if (!audioElement._ksConnected) {
                    const source = ctx.createMediaElementSource(audioElement);
                    source.connect(this.analyser);
                    this.analyser.connect(ctx.destination);
                    audioElement._ksConnected = true;
                }
            } catch (connErr) {
                this.startSimulatedAnalysis(voiceId);
                return;
            }

            const bufferLength = this.analyser.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            let smoothedAmp = 0;
            let lastStateChangeTime = 0;
            let currentActiveState = 'open';
            let cycleIndex = 0;
            const cadenceStates = ['slightly_open', 'open', 'wide_open', 'open', 'smile', 'open', 'slightly_open', 'open'];

            const updateLoop = (timestamp) => {
                if (!this.isSpeaking || !this.currentAudio || this.currentAudio.paused || this.currentAudio.ended) {
                    this.broadcastAmplitude(0, 'closed', voiceId);
                    this.animFrameId = null;
                    return;
                }

                // If within trailing silence window of audio end, close mouth instantly
                if (audioElement.duration && audioElement.duration > 0 && (audioElement.duration - audioElement.currentTime <= 0.22)) {
                    this.broadcastAmplitude(0, 'closed', voiceId);
                    this.animFrameId = requestAnimationFrame(updateLoop);
                    return;
                }

                const now = timestamp || performance.now();
                this.analyser.getByteFrequencyData(dataArray);
                let sum = 0;
                for (let i = 0; i < bufferLength; i++) {
                    sum += dataArray[i];
                }
                const rawAmp = (sum / bufferLength) / 255;
                smoothedAmp = (smoothedAmp * 0.35) + (rawAmp * 0.65);

                // Update mouth state at natural human phoneme rate (~85ms per viseme) to avoid stopping or jitter
                if (now - lastStateChangeTime > 85) {
                    lastStateChangeTime = now;
                    let nextState = 'open';

                    if (smoothedAmp > 0.30) {
                        nextState = (Math.random() < 0.6) ? 'wide_open' : 'open';
                    } else if (smoothedAmp > 0.12) {
                        nextState = (Math.random() < 0.65) ? 'open' : 'slightly_open';
                    } else if (smoothedAmp > 0.03) {
                        nextState = (Math.random() < 0.5) ? 'slightly_open' : 'smile';
                    } else {
                        // Natural phonetic cadence between syllables so mouth stays alive continuously
                        cycleIndex = (cycleIndex + 1) % cadenceStates.length;
                        nextState = cadenceStates[cycleIndex];
                    }

                    currentActiveState = nextState;
                    const effectiveAmp = Math.max(0.18, smoothedAmp);
                    this.broadcastAmplitude(effectiveAmp, currentActiveState, voiceId);
                }

                this.animFrameId = requestAnimationFrame(updateLoop);
            };

            this.animFrameId = requestAnimationFrame(updateLoop);
        } catch (e) {
            this.startSimulatedAnalysis(voiceId);
        }
    }

    startSimulatedAnalysis(voiceId) {
        this.stopAudioAnalysis();
        let lastStateChangeTime = 0;
        let cycleIndex = 0;
        const cadenceStates = ['slightly_open', 'open', 'wide_open', 'open', 'smile', 'open', 'slightly_open', 'open'];

        const simulatedLoop = (timestamp) => {
            if (!this.isSpeaking) {
                this.broadcastAmplitude(0, 'closed', voiceId);
                this.animFrameId = null;
                return;
            }

            const now = timestamp || performance.now();
            if (now - lastStateChangeTime > 85) {
                lastStateChangeTime = now;
                cycleIndex = (cycleIndex + 1) % cadenceStates.length;
                const nextState = cadenceStates[cycleIndex];
                const pseudoAmp = nextState === 'wide_open' ? 0.85 : (nextState === 'open' ? 0.55 : 0.28);
                this.broadcastAmplitude(pseudoAmp, nextState, voiceId);
            }

            this.animFrameId = requestAnimationFrame(simulatedLoop);
        };
        this.animFrameId = requestAnimationFrame(simulatedLoop);
    }

    stopAudioAnalysis() {
        if (this.animFrameId) {
            cancelAnimationFrame(this.animFrameId);
            this.animFrameId = null;
        }
        this.broadcastAmplitude(0, 'closed');
    }

    broadcastAmplitude(amplitude, mouthState, voiceId) {
        this.currentAmplitude = amplitude;
        this.currentMouthState = mouthState;
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('ks_coach_amplitude', {
                detail: {
                    amplitude,
                    mouthState,
                    isSpeaking: this.isSpeaking,
                    voiceId: voiceId || this.getUserVoice()
                }
            }));
        }
    }

    playAudioUrl(audioUrl, { onStart, onEnd, onError, chosenVoiceId, pitch, speakingRate } = {}) {
        if (!audioUrl) return false;
        try {
            this.stop();
            const audio = new Audio();
            audio.crossOrigin = 'anonymous';
            audio.src = audioUrl;
            audio.volume = 1.0;
            this.currentAudio = audio;

            audio.onplay = () => {
                this.isSpeaking = true;
                this.startAudioAnalysis(audio, chosenVoiceId);
                if (onStart) onStart();
            };

            audio.ontimeupdate = () => {
                if (audio.duration && audio.duration > 0 && (audio.duration - audio.currentTime <= 0.18)) {
                    this.broadcastAmplitude(0, 'closed', chosenVoiceId);
                }
            };

            audio.onpause = () => {
                if (audio.ended || audio.paused) {
                    this.isSpeaking = false;
                    this.stopAudioAnalysis();
                }
            };

            audio.onended = () => {
                this.isSpeaking = false;
                this.stopAudioAnalysis();
                this.currentAudio = null;
                if (onEnd) onEnd();
            };

            audio.onerror = (e) => {
                console.warn('[CoachVoice] Audio URL error:', e);
                this.isSpeaking = false;
                this.stopAudioAnalysis();
                this.currentAudio = null;
                if (onError) {
                    onError(e);
                }
            };

            const playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.catch(playErr => {
                    console.warn('[CoachVoice] Audio URL playback error:', playErr.message);
                    this.isSpeaking = false;
                    this.stopAudioAnalysis();
                    this.currentAudio = null;
                    if (onError) {
                        onError(playErr);
                    }
                });
            }

            return true;
        } catch (err) {
            console.warn('[CoachVoice] playAudioUrl failed:', err.message);
            if (onError) onError(err);
            return false;
        }
    }

    playBase64Audio(base64Audio, { onStart, onEnd, onError, chosenVoiceId, pitch, speakingRate } = {}) {
        try {
            this.stop();
            const binaryString = window.atob(base64Audio);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: 'audio/mp3' });
            const blobUrl = URL.createObjectURL(blob);
            const audio = new Audio(blobUrl);
            audio.volume = 1.0;
            this.currentAudio = audio;

            audio.onplay = () => {
                this.isSpeaking = true;
                this.startAudioAnalysis(audio, chosenVoiceId);
                if (onStart) onStart();
            };

            audio.ontimeupdate = () => {
                if (audio.duration && audio.duration > 0 && (audio.duration - audio.currentTime <= 0.18)) {
                    this.broadcastAmplitude(0, 'closed', chosenVoiceId);
                }
            };

            audio.onpause = () => {
                if (audio.ended || audio.paused) {
                    this.isSpeaking = false;
                    this.stopAudioAnalysis();
                }
            };

            audio.onended = () => {
                this.isSpeaking = false;
                this.stopAudioAnalysis();
                this.currentAudio = null;
                URL.revokeObjectURL(blobUrl);
                if (onEnd) onEnd();
            };

            audio.onerror = (e) => {
                console.warn('[CoachVoice] Base64 audio error:', e);
                this.isSpeaking = false;
                this.stopAudioAnalysis();
                this.currentAudio = null;
                URL.revokeObjectURL(blobUrl);
                if (onError) {
                    onError(e);
                }
            };

            const playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.catch(playErr => {
                    console.warn('[CoachVoice] Audio playback promise error:', playErr.message);
                    this.isSpeaking = false;
                    this.stopAudioAnalysis();
                    this.currentAudio = null;
                    URL.revokeObjectURL(blobUrl);
                    if (onError) {
                        onError(playErr);
                    }
                });
            }

            return true;
        } catch (err) {
            console.warn('[CoachVoice] playBase64Audio failed:', err.message);
            if (onError) onError(err);
            return false;
        }
    }

    speakWithBrowserSynth(speechText, chosenVoiceId, { onStart, onEnd, onError } = {}) {
        // Disabled: Free/fallback device synthesizer audio is completely removed per user request
        if (onError) onError(new Error('Browser speech synthesis is disabled'));
        return false;
    }

    /**
     * Fetch AI coach commentary and audio for a puzzle move (correct or wrong)
     * Leverages position-hash caching + instant local in-memory cache
     */
    async fetchPuzzleMoveCommentary({ fen, playedMove, isCorrect, solutionMove, puzzleRating, playerElo, coachVoice, language, askCoach = false, isSolved = false, isFinalMove = false }) {
        if (!fen) return null;

        const currentVoice = coachVoice || this.getUserVoice();
        const allVoices = this.getAllVoices();
        const voiceDef = allVoices.find(v => v.id === currentVoice) || ALL_COACH_VOICES.find(v => v.id === currentVoice);
        const effectiveLang = language || (voiceDef?.langCode ? voiceDef.langCode.split('-')[0] : 'en');
        
        let moveKey = 'ask_coach';
        if (typeof playedMove === 'string' && playedMove.trim()) {
            moveKey = playedMove.trim();
        } else if (playedMove && typeof playedMove === 'object') {
            moveKey = playedMove.san || (playedMove.from && playedMove.to ? `${playedMove.from}${playedMove.to}` : (playedMove.lan || 'move'));
        } else if (!playedMove) {
            moveKey = askCoach ? 'ask_coach' : 'none';
        }

        const cacheKey = `${fen}_${moveKey}_${askCoach ? 'askcoach_' : ''}${isSolved ? 'solved_' : ''}${effectiveLang}_${currentVoice}`;

        if (!this.puzzleCommentaryCache) {
            this.puzzleCommentaryCache = new Map();
        }

        if (this.puzzleCommentaryCache.has(cacheKey)) {
            return this.puzzleCommentaryCache.get(cacheKey);
        }

        // Check persistent localStorage cache with TTL (24 hours default)
        const storageCacheKey = `ks_puzzle_commentary_${cacheKey}`;
        try {
            if (typeof localStorage !== 'undefined') {
                const storedRaw = localStorage.getItem(storageCacheKey);
                if (storedRaw) {
                    const parsed = JSON.parse(storedRaw);
                    const now = Date.now();
                    const ttlMs = parsed.ttl || (24 * 60 * 60 * 1000);
                    if (now - (parsed.timestamp || 0) < ttlMs && parsed.data) {
                        this.puzzleCommentaryCache.set(cacheKey, parsed.data);
                        return parsed.data;
                    } else {
                        localStorage.removeItem(storageCacheKey);
                    }
                }
            }
        } catch (_) {}

        this._inFlightPuzzleRequests = this._inFlightPuzzleRequests || new Map();
        if (this._inFlightPuzzleRequests.has(cacheKey)) {
            return this._inFlightPuzzleRequests.get(cacheKey);
        }

        const fetchPromise = (async () => {
            try {
                const endpoint = API_CONFIG?.getUrl ? API_CONFIG.getUrl('/analyze/puzzle-commentary') : (API_CONFIG?.BASE_URL || API_CONFIG?.baseURL || 'http://localhost:5025/api') + '/analyze/puzzle-commentary';
                const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
                const headers = { 'Content-Type': 'application/json' };
                if (token) headers['Authorization'] = `Bearer ${token}`;

                const res = await axios.post(endpoint, {
                    fen,
                    playedMove: playedMove || null,
                    isCorrect: !!isCorrect,
                    solutionMove,
                    puzzleRating: puzzleRating || 1500,
                    playerElo: playerElo || 1200,
                    coachVoice: currentVoice,
                    language: effectiveLang,
                    askCoach: !!askCoach,
                    isSolved: !!(isSolved || isFinalMove),
                    isFinalMove: !!(isSolved || isFinalMove)
                }, { headers, timeout: 12000 });

                if (res.data && res.data.success) {
                    let cleanComment = (res.data.coachComment || '')
                        .replace(/^[^.\n?!]*\b(?:Tactical terms|Terms bolded|Rule verification|Checklist|Checked|Guidelines met)\b[^.\n?!]*[.?!:]\s*/gim, '')
                        .replace(/\b(?:Tactical terms bolded\??|Terms bolded\??|Rules? followed\??|Guidelines? met\??|Checklist:?)\s*(?:[^\n.]*\((?:Checked|Yes|Done)\))?/gi, '')
                        .replace(/\([^)]*(?:Checked|Verified|Correct|Yes)\)/gi, '')
                        .replace(/\[[^\]]*(?:Checked|Verified|Correct|Yes|x)\]/gi, '')
                        .replace(/^(?:Is\s+|Are\s+|Do\s+|Did\s+|Tactical\s+terms)[^.!?]*\?\s*/i, '')
                        .replace(/^\s*(?:\*\*)?(?:Here(?:\s+is|\s*'s|\s+are)\s+(?:the\s+)?(?:direct\s+)?(?:translation|translated\s+text)[^:\n]*|Translation(?:\s+to\s+[a-zA-Z\s]+)?|Translated(?:\s+text)?(?:\s+to\s+[a-zA-Z\s]+)?|to\s+[a-zA-Z]+|पुनरावृत्ति|अनुकृति|अनुवाद)(?:\*\*)?\s*:\s*(?:\*\*(?!\w))?\s*/im, '')
                        .replace(/^[\s•\-–—]+/, '')
                        .replace(/^\*(?!\*)\s+/, '')
                        .replace(/\s{2,}/g, ' ')
                        .trim();

                    const starCount = (cleanComment.match(/\*\*/g) || []).length;
                    if (starCount % 2 !== 0) {
                        cleanComment = cleanComment.replace(/\*\*/, '');
                    }

                    const data = {
                        comment: cleanComment || res.data.coachComment || '',
                        quality: res.data.quality || (isCorrect ? 'best' : 'mistake'),
                        audioUrl: res.data.audioUrl || null,
                        moveSan: res.data.moveSan || (moveKey !== 'ask_coach' && moveKey !== 'none' ? moveKey : ''),
                        cached: !!res.data.cached,
                        askCoach: !!askCoach
                    };
                    if (res.data.audioUrl) {
                        const speechKeyText = this.cleanChessTextForSpeech(data.comment);
                        const vPitch = parseFloat(voiceDef?.voicePitch || voiceDef?.voice_pitch || 0.0);
                        const vRate = parseFloat(voiceDef?.speakingRate || voiceDef?.speaking_rate || 1.0);
                        this.clientAudioCache.set(`${currentVoice}_${speechKeyText}_${vPitch}_${vRate}`, res.data.audioUrl);
                    }
                    this.puzzleCommentaryCache.set(cacheKey, data);
                    try {
                        if (typeof localStorage !== 'undefined') {
                            localStorage.setItem(storageCacheKey, JSON.stringify({
                                data,
                                timestamp: Date.now(),
                                ttl: 24 * 60 * 60 * 1000 // 24 hours TTL
                            }));
                        }
                    } catch (_) {}
                    return data;
                }
            } catch (e) {
                console.warn('[CoachVoiceService] fetchPuzzleMoveCommentary error:', e.message);
            } finally {
                if (this._inFlightPuzzleRequests) {
                    this._inFlightPuzzleRequests.delete(cacheKey);
                }
            }

            // Local fallback
            const fallbackComment = askCoach
                ? (moveKey && moveKey !== 'ask_coach' && moveKey !== 'none'
                    ? `Playing **${moveKey}** misses the tactical motif. Focus your attention on the opponent's undefended pieces and forcing checks to find the winning sequence.`
                    : `Focus your attention on the opponent's undefended pieces and forcing checks to find the winning sequence.`)
                : (isCorrect 
                    ? `Correct move with **${moveKey}**! Well done finding the winning solution.`
                    : `Playing **${moveKey}** is inaccurate. Look for a sharper tactical move, or click Ask Coach for a clue.`);
            const fallbackData = {
                comment: this.translateSync(fallbackComment, effectiveLang),
                quality: isCorrect ? 'best' : 'mistake',
                audioUrl: null,
                moveSan: moveKey !== 'ask_coach' && moveKey !== 'none' ? moveKey : '',
                fallback: true,
                askCoach: !!askCoach
            };
            this.puzzleCommentaryCache.set(cacheKey, fallbackData);
            try {
                if (typeof localStorage !== 'undefined') {
                    localStorage.setItem(storageCacheKey, JSON.stringify({
                        data: fallbackData,
                        timestamp: Date.now(),
                        ttl: 60 * 60 * 1000 // 1 hour TTL for fallback
                    }));
                }
            } catch (_) {}
            return fallbackData;
        })();

        this._inFlightPuzzleRequests.set(cacheKey, fetchPromise);
        return fetchPromise;
    }

    /**
     * Background preload for puzzle solution moves
     */
    async preloadPuzzleCommentary(puzzles = []) {
        if (!Array.isArray(puzzles) || puzzles.length === 0) return;
        try {
            const endpoint = API_CONFIG?.getUrl ? API_CONFIG.getUrl('/analyze/puzzle-preload') : (API_CONFIG?.BASE_URL || API_CONFIG?.baseURL || 'http://localhost:5025/api') + '/analyze/puzzle-preload';
            const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
            const headers = { 'Content-Type': 'application/json' };
            if (token) headers['Authorization'] = `Bearer ${token}`;
            const currentVoice = this.getUserVoice();

            await axios.post(endpoint, {
                puzzles: puzzles.slice(0, 5),
                coachVoice: currentVoice
            }, { headers, timeout: 5000 });
        } catch (e) {}
    }

    stop() {
        this.speakSessionId = (this.speakSessionId || 0) + 1;
        if (this.activeAbortController) {
            try { this.activeAbortController.abort(); } catch (err) {}
            this.activeAbortController = null;
        }
        this.stopAudioAnalysis();
        if (this.currentAudio) {
            try {
                this.currentAudio.pause();
                this.currentAudio.currentTime = 0;
                this.currentAudio.src = '';
                this.currentAudio.onplay = null;
                this.currentAudio.onended = null;
                this.currentAudio.ontimeupdate = null;
                this.currentAudio.onpause = null;
                this.currentAudio.onerror = null;
                this.currentAudio = null;
            } catch (e) {}
        }
        if (typeof window !== 'undefined' && window.speechSynthesis) {
            try {
                window.speechSynthesis.cancel();
            } catch (e) {}
        }
        if (this.synth) {
            try {
                this.synth.cancel();
                this.currentUtterance = null;
            } catch (e) {}
        }
        this.isSpeaking = false;
    }
}

const coachVoiceService = new CoachVoiceService();

if (typeof window !== 'undefined' && window.speechSynthesis) {
    const unlockSpeech = () => {
        try {
            if (window.speechSynthesis.paused) {
                window.speechSynthesis.resume();
            }
        } catch (e) {}
    };
    window.addEventListener('click', unlockSpeech, { passive: true });
    window.addEventListener('touchstart', unlockSpeech, { passive: true });
}

export default coachVoiceService;
